"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Back4app2Error_1 = require("./Back4app2Error");
var CreateParseAppError = /** @class */ (function (_super) {
    __extends(CreateParseAppError, _super);
    function CreateParseAppError(message) {
        var _this = _super.call(this, message, CreateParseAppError.CODE) || this;
        Object.setPrototypeOf(_this, CreateParseAppError.prototype);
        return _this;
    }
    CreateParseAppError.CODE = 'CREATE_PARSE_APP_ERROR';
    return CreateParseAppError;
}(Back4app2Error_1.default));
exports.default = CreateParseAppError;
